var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.183,
    height: 25.1,
    viewBox: "0 0 21.183 25.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6606",
    "data-name": "Group 6606",
    transform: "translate(-1591.2 -452.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7825",
    "data-name": "Path 7825",
    d: "M14,3V8.222a1.306,1.306,0,0,0,1.306,1.306h5.222",
    transform: "translate(1589.75 450)",
    fill: "none",
    stroke: "#1a3173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7826",
    "data-name": "Path 7826",
    d: "M5,14.75V5.611A2.611,2.611,0,0,1,7.611,3H16.75l6.528,6.528V14.75",
    transform: "translate(1587 450)",
    fill: "none",
    stroke: "#1a3173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7827",
    "data-name": "Path 7827",
    d: "M5,18.917H6.958a1.958,1.958,0,1,0,0-3.917H5v7.833",
    transform: "translate(1587 453.667)",
    fill: "none",
    stroke: "#1a3173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7828",
    "data-name": "Path 7828",
    d: "M17,18h2.611",
    transform: "translate(1590.667 454.583)",
    fill: "none",
    stroke: "#1a3173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7829",
    "data-name": "Path 7829",
    d: "M20.917,15H17v7.833",
    transform: "translate(1590.667 453.667)",
    fill: "none",
    stroke: "#1a3173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7830",
    "data-name": "Path 7830",
    d: "M11,15v7.833h1.306a2.611,2.611,0,0,0,2.611-2.611V17.611A2.611,2.611,0,0,0,12.306,15Z",
    transform: "translate(1588.833 453.667)",
    fill: "none",
    stroke: "#1a3173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.833f35a2d13c4aeafdf8898aa4eefa22.svg";
export { ForwardRef as ReactComponent };